import { RouteConfig } from 'vue-router';
import { multiGuard } from '../Middleware/MultiGuard';
import { permissionClassesFeature } from '../Middleware/permission/Classes';

import { onboardingClasses } from '../Middleware/onboarding/index';
import { handleRedirect } from '../Middleware/testCorrection/index';

export const NAME_ROUTES_CLASSES = {
  LIST: 'Classes',
  CLASS_ROOM: 'ClassRoom',
  WALL: 'Mural',
  ACTIVITIES: 'Atividades',
  COURSE: 'Course',
  TUTORIAL: 'TutorialClasses',
  NOTES: 'Notes',
  ACTIVITY_DETAIL: 'atividade-detalhes',
  ADD_TEMPLATE: 'adicionar-gabarito',
  SEE_DELIVERY: 'see-delivery',
  TEST_CORRECTION: 'prova-correcao'
};

export const Classes: Array<RouteConfig> = [
  {
    path: '/provas/corrigir',
    component: () => import('@/layouts/Default/index.vue'),
    children: [
      {
        path: '',
        name: NAME_ROUTES_CLASSES.TEST_CORRECTION,
        beforeEnter: handleRedirect
      }
    ]
  },
  {
    path: '/turma/:idClass/atividades/:activityId/detalhes',
    component: () => import('@/layouts/Default/index.vue'),
    children: [
      {
        path: '',
        name: NAME_ROUTES_CLASSES.ACTIVITY_DETAIL,
        component: () => import(/* webpackChunkName: "atividade-detalhes" */ '@/pages/Classes/pages/Activities/pages/ActivityDetails/index.vue')
      }
    ]
  },
  {
    path: '/turma/:idClass/atividades/:activityId/detalhes/adicionar-gabarito',
    component: () => import('@/layouts/Default/index.vue'),
    children: [
      {
        path: '',
        name: NAME_ROUTES_CLASSES.ADD_TEMPLATE,
        component: () => import(/* webpackChunkName: "adicionar-gabarito" */ '@/pages/Classes/pages/Activities/pages/ActivityDetails/pages/AddTemplate/index.vue')
      }
    ]
  },
  {
    path: '/turma/:idClass/atividades/:activityId/detalhes/ver-entrega',
    component: () => import('@/layouts/Default/index.vue'),
    children: [
      {
        path: '',
        name: NAME_ROUTES_CLASSES.SEE_DELIVERY,
        component: () => import(/* webpackChunkName: "ver-entrega" */ '@/pages/Classes/pages/Activities/pages/ActivityDetails/pages/SeeDelivery/index.vue')
      }
    ]
  },
  {
    path: '/minhas-turmas',
    component: () => import('@/layouts/Default/index.vue'),
    children: [
      {
        path: '',
        name: NAME_ROUTES_CLASSES.LIST,
        component: () => import(/* webpackChunkName: "turmas" */ '@/pages/Classes/index.vue'),
        meta: { title: 'Minhas turmas' },
        beforeEnter: multiGuard([
          permissionClassesFeature,
          onboardingClasses
        ])
      },
      {
        path: 'tutorial',
        name: NAME_ROUTES_CLASSES.TUTORIAL,
        component: () => import(
          /* webpackChunkName: "doubts-classes" */ '@/pages/Classes/pages/TutorialClasses/TutorialClasses.vue'
        ),
        meta: { title: 'Tutorial Turmas' },
        beforeEnter: multiGuard([
          // permissionClassesFeature,
          // onboardingClasses
        ])
      }
    ]
  },
  {
    path: '/turma',
    component: () => import('@/layouts/Default/index.vue'),
    children: [
      {
        path: ':idClass',
        name: NAME_ROUTES_CLASSES.CLASS_ROOM,
        component: () => import(/* webpackChunkName: "turma" */ '@/pages/Classes/pages/ClassRoom/index.vue'),
        children: [
          {
            path: 'mural',
            name: NAME_ROUTES_CLASSES.WALL,
            component: () => import(/* webpackChunkName: "mural" */ '@/pages/Classes/pages/Wall/index.vue'),
            meta: { title: 'Mural' }
          },
          {
            path: 'atividades',
            name: NAME_ROUTES_CLASSES.ACTIVITIES,
            component: () => import(/* webpackChunkName: "atividades" */ '@/pages/Classes/pages/Activities/index.vue'),
            meta: { title: 'Atividades' }
          },
          {
            path: 'curso',
            name: NAME_ROUTES_CLASSES.COURSE,
            component: () => import(/* webpackChunkName: "curso" */ '@/pages/Classes/pages/Course/index.vue'),
            meta: { title: 'Curso' }
          },
          {
            path: 'notas',
            name: NAME_ROUTES_CLASSES.NOTES,
            component: () => import(/* webpackChunkName: "notas" */ '@/pages/Classes/pages/Notes/index.vue'),
            meta: { title: 'Notas' }
          }
        ]
      }
    ]
  }
];
